import React from 'react';
import { observable } from 'mobx';
import Styled from 'styled';
import Localizable from 'lib/intl/localizable';
import { observer } from 'mobx-react';
import InputView from 'four-nets/ui/text-input-view';
import defaultStyles from './text-input-view.scss';

@Localizable()
@Styled(defaultStyles)
@observer
class TextInputView extends React.Component {
    @observable focused = false;

    onFocus = event => {
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }

        this.focused = true;
    };

    onBlur = event => {
        this.props.field.data.onBlur(event);

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }

        this.focused = false;
    };

    onChange = event => {
        this.props.field.data.onChange(event);

        if (this.props.onChange) {
            this.props.onChange(event);
        }
    };

    render() {
        const { field, autocompleteElement, id, intl, type, styles, elementsBeforeInput, ...rest } = this.props;

        const { formatMessage } = intl;

        const {
            placeholder,
            label,
            data: { dirty, touched, valid, validationErrors, value, visited },
        } = field;

        const showValidationErrors = (visited || dirty || touched) && !valid;

        return (
            <div className={styles.textInput}>
                <InputView
                    id={id}
                    type={type || 'text'}
                    value={value || ''}
                    label={label}
                    placeholder={placeholder}
                    invalid={showValidationErrors}
                    elementsBeforeInput={elementsBeforeInput}
                    {...rest}
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />
                {showValidationErrors &&
                    validationErrors.map((error, index) => {
                        if (error.intlMessage) {
                            return (
                                <p key={index.toString()} className={styles.error}>
                                    {formatMessage(error.intlMessage)}
                                </p>
                            );
                        }
                        // this is used for server errors, which can contain html
                        return (
                            <p
                                key={index.toString()}
                                className={styles.error}
                                dangerouslySetInnerHTML={{ __html: error }}
                            />
                        );
                    })}
                <div className={styles.autocomplete}>{autocompleteElement}</div>
            </div>
        );
    }
}

export default TextInputView;
